import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDots = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 22 22",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "dots" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "dots",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsxs("g", {
				transform: "translate(0.000000, 9.000000)",
				fill: "currentColor",
				fillRule: "nonzero",
				id: "Oval",
				children: [
					/* @__PURE__ */ _jsx("circle", {
						transform: "translate(11.000000, 2.000000) rotate(90.000000) translate(-11.000000, -2.000000) ",
						cx: 11,
						cy: 2,
						r: 2
					}),
					/* @__PURE__ */ _jsx("circle", {
						transform: "translate(2.000000, 2.000000) rotate(90.000000) translate(-2.000000, -2.000000) ",
						cx: 2,
						cy: 2,
						r: 2
					}),
					/* @__PURE__ */ _jsx("circle", {
						transform: "translate(20.000000, 2.000000) rotate(90.000000) translate(-20.000000, -2.000000) ",
						cx: 20,
						cy: 2,
						r: 2
					})
				]
			})
		})
	]
});
const ForwardRef = forwardRef(SvgDots);
export default ForwardRef;
